class BrandPage{
    constructor(){
        this.init();
    }
    changeEvent = () =>{
        
        let searchInput = document.querySelector('.brand-search #search-brand');
        searchInput.addEventListener('keyup',(e)=>{
            let value = searchInput.value;

            let targets = document.querySelectorAll('.brand-page-item');
            targets.forEach((item)=>{
                const allItems = item.querySelectorAll(`.vendor-item`);
                allItems.forEach((el)=> el.classList.remove('hidden'))
                if(!value){
                    item.classList.remove('hidden');
                }else{
                    item.classList.add('hidden');
                }
            })
            if(!value){
                return
            }

            targets.forEach((item)=>{
                const elements = item.querySelectorAll(`.vendor-item[data-value^="${value}"]`);
                if(elements.length > 0){
                    item.classList.remove('hidden');
                    const allItems = item.querySelectorAll(`.vendor-item`);
                    allItems.forEach((el)=> el.classList.add('hidden'))
                    elements.forEach((el)=> el.classList.remove('hidden'))
                }
            })
            
        })
    }
    clickEvent = () =>{
        let letters = document.querySelectorAll('.list-letters .letter-item');
        letters.forEach((item)=>{
            item.addEventListener('click',(e)=>{
                let value = item.dataset.item;
                if(value){
                    let header = document.querySelector('.header-wrapper')?.offsetHeight || 0;
                    let target = document.querySelector(`.brand-items .brand-page-item[data-item="${value}"]`);
                    if(target){
                        window.scrollTo({ top: target.offsetTop - (header + 20), behavior: 'smooth' })
                    }
                }
            })
        })
    }

    init = () =>{
        this.clickEvent();
        this.changeEvent();
    }
}
if(document.querySelector('.brand-page')) new BrandPage();
